import styled, {css} from 'styled-components'

export const StyledRecipientRow = styled.div(
    ({theme: {palette, spacing}}) => css`
        display: flex;
        align-items: center;
        gap: ${spacing * 3}px;
        padding: ${spacing * 2.5}px 0;
        border-bottom: 1px solid ${palette.neutral[100]};

        &:last-of-type {
            border-bottom: none;
        }
    `
)

export const StyledRecipientInfo = styled.div(
    () => css`
        display: flex;
        flex-direction: column;
        gap: 2px;
        flex: 1;
        min-width: 0;
    `
)

export const StyledRecipientName = styled.span(
    ({theme: {typography, palette}}) => css`
        ${typography.textSm};
        font-weight: 500;
        color: ${palette.neutral[800]};
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    `
)

export const StyledRecipientEmail = styled.span(
    ({theme: {typography, palette}}) => css`
        ${typography.textXs};
        color: ${palette.neutral[500]};
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    `
)

export const StyledSectionHeader = styled.div(
    ({theme: {palette, spacing, typography}}) => css`
        display: flex;
        align-items: center;
        gap: ${spacing * 1.5}px;
        padding: ${spacing * 1.5}px ${spacing * 2}px;
        background: ${palette.neutral[50]};
        border-radius: 8px;
        margin-bottom: ${spacing * 1}px;
        ${typography.textSm};
        font-weight: 600;
        color: ${palette.neutral[700]};
    `
)

export const StyledLoadMoreWrapper = styled.div(
    ({theme: {spacing}}) => css`
        display: flex;
        justify-content: center;
        padding-top: ${spacing * 2}px;
    `
)

export const StyledScrollContainer = styled.div(
    () => css`
        max-height: 65vh;
        overflow-y: auto;
        display: flex;
        flex-direction: column;
        gap: 20px;
    `
)

export const StyledSectionBlock = styled.div(
    () => css`
        display: flex;
        flex-direction: column;
    `
)

export const StyledTabsBar = styled.div(
    ({theme: {palette, spacing}}) => css`
        display: flex;
        border-bottom: 1px solid ${palette.neutral[200]};
        margin-bottom: ${spacing * 3}px;
        flex-shrink: 0;
    `
)

export const StyledTabButton = styled.button<{$active: boolean}>(
    ({theme: {palette, typography, spacing}, $active}) => css`
        display: flex;
        align-items: center;
        gap: ${spacing * 1.5}px;
        padding: ${spacing * 2}px ${spacing * 3}px;
        background: none;
        border: none;
        border-bottom: 2px solid ${$active ? palette.primary[500] : 'transparent'};
        color: ${$active ? palette.primary[500] : palette.neutral[500]};
        ${typography.textSm};
        font-weight: ${$active ? 600 : 400};
        cursor: pointer;
        transition:
            color 0.15s,
            border-color 0.15s;

        &:hover {
            color: ${palette.primary[500]};
        }
    `
)

export const StyledTabCount = styled.span<{$active: boolean}>(
    ({theme: {palette, typography, spacing}, $active}) => css`
        display: inline-flex;
        align-items: center;
        justify-content: center;
        min-width: 20px;
        height: 20px;
        padding: 0 ${spacing * 1}px;
        border-radius: 10px;
        background: ${$active ? palette.primary[50] : palette.neutral[100]};
        color: ${$active ? palette.primary[600] : palette.neutral[500]};
        ${typography.textXs};
        font-weight: 600;
    `
)

export const StyledEmptyState = styled.div(
    ({theme: {palette, spacing, typography}}) => css`
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: ${spacing * 2}px;
        padding: ${spacing * 8}px ${spacing * 4}px;
        color: ${palette.neutral[400]};
        ${typography.textSm};
        text-align: center;
    `
)
